import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Layout from './components/Layout';

import Home from './components/Home';
import About from './components/About';
import Career from './components/Career';
import Contact from './components/Contact';
import Counter from './components/Counter';
import FetchData from './components/FetchData';
import Services from './components/Services';
import PrivacyPolicy from './components/PrivacyPolicy';

import './custom.css'

export default () => (
    <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/about' component={About} />
        <Route path='/job-opportunities' component={Career} />
        <Route path='/privacy' component={PrivacyPolicy} />
        <Route path='/contact-us' component={Contact} />
        <Route path='/counter' component={Counter} />
        <Route path='/services/:serviceType' component={Services} />
        <Route path='/fetch-data/:startDateIndex?' component={FetchData} />
    </Layout>
);
